import { gql } from '@/modes/waterSupplier/gql';

export const GET_WATER_SERVICE_FOR_HAZARD_SURVEY = gql(`
  query GetWaterServiceForHazardSurvey($where: JSON) {
    waterServices(where: $where) {
      id
      siteNumber
      meterNumber
      meterSize
      address {
        id
        street1
        street2
      }
      waterServiceHazards {
        waterHazardId
        isProtected
        backflowAssemblyId
        waterHazard {
          id
          name
          hazardLevel
        }
      }
      backflowAssemblies(where: { status: true }) {
        id
        model {
          name
          backflowAssemblyMake {
            name
          }
        }
        size
        serialNumber
        location
        type
        hazardType
        hazardLevel
        status
        testStatus
        testAnniversary
        lastTestDate
        lastTest {
          jobId
          initialResult
          finalResult
        }
      }
    }
  }
`);

export const GET_HAZARD_SURVEY_JOB = gql(`
  query HazardSurveyJob($where: JSON) {
    jobs(where: $where) {
      id
      secureKey
      scheduled
      waterHazardSurvey(required: true) {
        jobId
        waterService(required: true) {
          id
          siteNumber
          meterNumber
          hazardSite {
            id
            name
            siteNumber
          }
          meterSize
          address {
            id
            street1
            street2
          }
          waterServiceHazards {
            waterHazardId
            isProtected
            backflowAssemblyId
            waterHazard {
              id
              name
              hazardLevel
            }
          }
          backflowAssemblies(where: { status: true}) {
            id
            model {
              name
              backflowAssemblyMake {
                name
              }
            }
            size
            serialNumber
            testAnniversary
            lastTestDate
            lastTest {
              jobId
              initialResult
              finalResult
            }
            status
            testStatus
            location
            type
            hazardType
            hazardLevel
          }
        }
        contactProfileId
        contact {
          id
          type
          name
          firstName
          lastName
          phones {
            id
            subType
            value
            extension
          }
          emails {
            id
            subType
            value
          }
        }
        status
        instructions
        otherHazardsQuestion
        protectedQuestion
        otherHazardsAnswer
        submitterName
        submitterPhone
        submitterEmail
        comments
        items {
          surveyId
          waterHazardId
          displayOrder
          answer
          isProtected
          backflowAssemblyId
          waterHazard {
            id
            name
            description
            hazardLevel
          }
        }
      }
      outboundAssignment {
        id
        status
        vendorProfile {
          id
          name
        }
      }
      address {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }
      attachments {
        id
        type
        contentType
        url
        thumb(size: 500)
        profile {
          id
          name
        }
        created
      }
      comments {
        id
        type
        visibility
        comment
        profile {
          id
          name
        }
        created
      }
      statusChanges {
        id
        fromStatus
        toStatus
        profile {
          id
          name
        }
        created
      }
    }
  }
`);

export const UPDATE_HAZARD_SURVEY = gql(`
  mutation UpdateHazardSurvey($jobId: ID!, $input: WaterHazardSurveyInput!) {
    updateWaterHazardSurvey(jobId: $jobId, input: $input) {
      jobId
      contactProfileId
      instructions
      otherHazardsQuestion
      items {
        surveyId
        waterHazardId
        displayOrder
        waterHazard {
          id
          name
          description
          hazardLevel
        }
      }
      contact {
        id
        type
        name
        firstName
        lastName
        phones {
          id
          subType
          value
          extension
        }
        emails {
          id
          subType
          value
        }
      }
      job {
        id
        scheduled
        outboundAssignment {
          id
          status
          vendorProfile {
            id
            name
          }
        }
      }
    }
  }
`);

export const ASSIGN_JOB = gql(`
  mutation AssignJob($jobId: ID!, $vendorProfileId: ID!) {
    assignJob(jobId: $jobId, vendorProfileId: $vendorProfileId) {
      id
      outboundAssignment {
        id
        vendorProfile {
          id
          name
        }
      }
    }
  }
`);

export const SCHEDULE_JOB = gql(`
  mutation ScheduleJob($jobId: ID!, $scheduled: String) {
    scheduleJob(jobId: $jobId, scheduled: $scheduled) {
      id
      scheduled
    }
  }
`);

export const ADD_JOB_ATTACHMENT = gql(`
  mutation AddHazardSurveyAttachment($jobId: ID!, $tempKey: String!, $contentType: String!) {
    addJobAttachment(jobId: $jobId, tempKey: $tempKey, contentType: $contentType) {
      id
      url
      thumb(size: 500)
      contentType
    }
  }
`);

export const SUBMIT_SURVEY_RESULTS = gql(`
  mutation SubmitSurveyResults($jobId: ID!, $input: SurveyResultsInput!) {
    submitSurveyResults(jobId: $jobId, input: $input) {
      jobId
      status
      submitterName
      submitterPhone
      submitterEmail
      otherHazardsAnswer
      comments
      items {
        surveyId
        waterHazardId
        answer
        isProtected
        backflowAssemblyId
      }
    }
  }
`);

export const UPDATE_HAZARD_SURVEY_STATUS = gql(`
  mutation UpdateHazardSurveyStatus($jobId: ID!, $status: WaterHazardSurveyStatus!, $comment: String, $updateWaterService: Boolean) {
    updateWaterHazardSurveyStatus(jobId: $jobId, status: $status, comment: $comment, updateWaterService: $updateWaterService) {
      jobId
      status
    }
  }
`);

export const BULK_UPDATE_HAZARD_SURVEY_STATUS = gql(`
  mutation BulkUpdateHazardSurveyStatus($jobIds: [ID!]!, $status: WaterHazardSurveyStatus!, $comment: String) {
    bulkUpdateWaterHazardSurveyStatus(jobIds: $jobIds, status: $status, comment: $comment) {
      jobId
      status
    }
  }
`);

export const CREATE_HAZARD_SURVEY = gql(`
  mutation CreateHazardSurvey(
    $waterServiceId: ID!
    $input: WaterHazardSurveyInput!
  ) {
    createWaterHazardSurvey(waterServiceId: $waterServiceId, input: $input) {
      jobId
      waterServiceId
      contactProfileId
      job {
        id
        addressId
      }
    }
  }
`);
